import { createSelector } from "reselect";
import { AppState } from "../appState";
import { ETab } from "../../constants";
import { tabPositionSelector } from "./tabSelectors";

// Base selectors
const filterExceptionCodeDataSelector = (state: AppState) =>
  state.exceptionCodeMasterData;
const allExceptionCodeDataSelector = (state: AppState) =>
  state.allExceptionCodeData;
const shortageExceptionCodeDataSelector = (state: AppState) =>
  state.shortageExceptionCodeData;
const damageExceptionCodeDataSelector = (state: AppState) =>
  state.damageExceptionCodeData;
const onHandDeliveryExceptionCodeDataSelector = (state: AppState) =>
  state.onHandDeliveryExceptionCodeData;
const misdeliveryExceptionCodeDataSelector = (state: AppState) =>
  state.misdeliveryExceptionCodeData;

// Memoized selector to get exception codes based on tab position
export const exceptionCodesSelector = createSelector(
  [
    tabPositionSelector,
    filterExceptionCodeDataSelector,
    allExceptionCodeDataSelector,
    shortageExceptionCodeDataSelector,
    damageExceptionCodeDataSelector,
    onHandDeliveryExceptionCodeDataSelector,
    misdeliveryExceptionCodeDataSelector,
  ],
  (
    tabPosition,
    exceptionCodeMasterData,
    allExceptionCodeData,
    shortageExceptionCodeData,
    damageExceptionCodeData,
    onHandDeliveryExceptionCodeData,
    misdeliveryExceptionCodeData
  ) => {
    const tabDataMap = {
      [ETab.overages]: exceptionCodeMasterData,
      [ETab.shortages]: shortageExceptionCodeData,
      [ETab.damages]: damageExceptionCodeData,
      [ETab.onHandDelivery]: onHandDeliveryExceptionCodeData,
      [ETab.misdelivery]: misdeliveryExceptionCodeData,
    };
    return tabDataMap[tabPosition as keyof typeof tabDataMap] ?? allExceptionCodeData;
  }
);
